import { get } from "./common/http";
import { BASE_URL } from "./common/const";
import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";

export const GetMasterBusinessAsList = () =>
   GET_ENC(`${BASE_URL}/api/Master/GetMasterBusinessAsList`, null);


export const GetMasterStatusList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Master/GetMasterStatusList?` + params, null);

export const GetSubSupplyTypes = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Master/GetSupplyType?` + params, null);

export const GetDocTypes = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Master/GetDocumentType?` + params, null);

export const GetTransactionTypes = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Master/GetTransactionType?` + params, null);

export const GetReasonForCancelation = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Master/GetReasonForCancelation?` + params, null);

export const GetReasonForExtend = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Master/GetReasonForExtend?` + params, null);

export const GetReasonForUpdate = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Master/GetReasonForUpdate?` + params, null);

export const GetExtendTransportationModes = () =>
   GET_ENC(`${BASE_URL}/api/Master/GetExtendTransportationModes`, null);

export const CheckUserNameAndPasswordIsExist = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Master/CheckUserNameAndPasswordIsExist?` + params, null);

export const CheckUserNameAndPassWordForEInvoice = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Master/CheckUserNameAndPassWordForEInvoice?` + params, null);

export const GetReferenceAndAdjustment = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Master/GetReferenceAndAdjustment?` + params, null);

export const GetListForIndustrytypeList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Master/GetListForIndustrytype?` + params, null);

export const GetLedgerReferenceByLedgerAccount = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Master/GetLedgerReferenceByLedgerAccount?` + params, null);

export const GetHsnSacList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Master/HsnSacList?` + params, null);

export const GetRefUsedList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Master/GetRefUsedList?` + params, null);

export const GetTaxabilityTypeList = () =>
   GET_ENC(`${BASE_URL}/api/Master/TaxabilityTypeList`, null);

export const GetNatureOfTransactionList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Master/NatureOfTransactionList?` + params, null);